import { FC } from 'react';

import { Slideout, SlideoutCommonProps } from 'components/design-system/Slideout';
import { formatPrice } from 'utils/text-helpers';

import { CommissionDetails } from './CommissionDetails';

export const CommissionDetailsModalTestIds = {
  container: 'commission-details-modal-container'
};

export type CommissionDetailsModalProps = {
  sellingPrice: number;
  minimalFee: number;
  commission: number;
  sellerFee: number;
  earnings: number;
} & SlideoutCommonProps;

export const CommissionDetailsModal: FC<CommissionDetailsModalProps> = ({
  isOpen,
  closeModal,
  commission,
  minimalFee,
  sellerFee,
  sellingPrice,
  earnings,
  ...props
}) => {
  const formattedEarnings = formatPrice(earnings);

  return (
    <Slideout
      data-testid={CommissionDetailsModalTestIds.container}
      title='Commission Details'
      isOpen={isOpen}
      closeModal={closeModal}
      {...props}
    >
      <CommissionDetails
        commission={commission}
        minimalFee={minimalFee}
        sellerFee={sellerFee}
        sellingPrice={sellingPrice}
      />
      <hr className='opacity-10 mt-4' />
      <div className='fs-16px letter-spacing-005 line-height-18px riforma-medium text-success d-flex justify-content-between'>
        <span>Earnings</span>
        <span>{formattedEarnings}</span>
      </div>
    </Slideout>
  );
};
